import React from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import LoginIcon from '@mui/icons-material/Login';
import AppOwnsDataWebApi from '../services/AppOwnsDataWebApi';

const LoginMenu = () => {
  const navigate = useNavigate();
  const isAuthenticated = Boolean(sessionStorage.getItem("isAuthenticated"));

  const loginUser = () => {
  };

  const logoutUser = () => {
  };

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  if (!isAuthenticated) {
    return (
      <Box sx={{ marginLeft: "auto", marginRight: "12px", pt: "4px" }}>
        <Button href={AppOwnsDataWebApi.SamlRoot + "InitiateSingleSignOn?returnUrl=" + window.location.href} onClick={loginUser} color="inherit" startIcon={<LoginIcon />}  >Login</Button>
      </Box>
    );

  }
}

export default LoginMenu;